<i18n>
{
  "fr": {
    "configuratorFooterPriceSummary": {
      "priceLabel": "{price}{pricePerUnit}{totalPriceWithoutVat}",
      "price": "{price}",
      "perUnit": "/gobelet",
      "vatIncluded": "\u00A0TTC",
      "vatExcluded": "\u00A0HT",
      "ie": "Soit"
    }
  }
}
</i18n>

<template>
  <i18n
    path="configuratorFooterPriceSummary.priceLabel"
    tag="span"
    class="configurator-footer-price-summary"
  >
    <template #price>
      <span class="configurator-footer-price-summary__price-value">
        {{
          $t('configuratorFooterPriceSummary.price', {
            price: $n(totalPrice, 'currency'),
          })
        }}<sup>{{ $t('configuratorFooterPriceSummary.vatIncluded') }}</sup>
      </span>
    </template>

    <template #pricePerUnit>
      <span class="configurator-footer-price-summary__ie">{{
        $t('configuratorFooterPriceSummary.ie')
      }}</span>
      <span class="configurator-footer-price-summary__price-per-unit">
        {{ $n(cupPrice, 'currency') }}
        <sup>{{ $t('configuratorFooterPriceSummary.vatIncluded') }}</sup>
      </span>
      <span class="configurator-footer-price-summary__per-unit">{{
        $t('configuratorFooterPriceSummary.perUnit')
      }}</span>
    </template>

    <template v-if="shouldDisplayTotalPriceWithoutVat" #totalPriceWithoutVat>
      <span class="configurator-footer-price-summary__total-price-without-vat">
        {{ '(' + $n(totalPriceWithoutVat, 'currency') }}
        {{ $t('configuratorFooterPriceSummary.vatExcluded') + ')' }}
      </span>
    </template>
  </i18n>
</template>

<script>
export default {
  name: 'ConfiguratorFooterPriceSummary',
  props: {
    cupPrice: {
      type: Number,
      default: undefined,
    },
    totalPrice: {
      type: Number,
      default: undefined,
    },
    totalPriceWithoutVat: {
      type: Number,
      default: undefined,
    },
    shouldDisplayTotalPriceWithoutVat: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-footer-price-summary {
  color: $color-gray-wild-sand;
  line-height: normal;
  text-align: start;
  font-size: 0.875rem; // 14px
  height: fit-content;
  margin: 0;

  &__price-value {
    display: block;
    font-size: 17px;
    font-weight: 600;

    @include breakpoint($breakpoint-configurator-l) {
      font-size: 1.5rem;
    }
  }

  &__ie {
    display: none;
    font-weight: 400;

    @include breakpoint(1325px) {
      display: inline-block;
    }
  }

  &__per-unit,
  &__price-per-unit {
    font-weight: 400;
  }

  &__total-price-without-vat {
    display: none;
    font-weight: 400;

    @include breakpoint(1325px) {
      display: inline-block;
    }
  }
}
</style>
